"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeTypeVars = exports.makeScheme = exports.unboundScheme = exports.tupleType = exports.arrayType = exports.polymorphicType = exports.functionType = exports.typeVar = void 0;
const type_1 = require("./type");
const util_1 = require("../../util");
function typeVar(name) {
    return {
        kind: type_1.TypeKind.Variable,
        name,
    };
}
exports.typeVar = typeVar;
function functionType(type1, type2, ...types) {
    const [last1, last2, ...rest] = [type1, type2, ...types].reverse();
    return rest.reduce((acc, type) => uncurriedFunctionType(type, acc), uncurriedFunctionType(last2, last1));
}
exports.functionType = functionType;
function polymorphicType(constructor, parameters) {
    return {
        kind: type_1.TypeKind.Polymorphic,
        constructor,
        parameters,
    };
}
exports.polymorphicType = polymorphicType;
function arrayType(type) {
    return polymorphicType(type_1.Constructor.Array, [type]);
}
exports.arrayType = arrayType;
function tupleType(...types) {
    const arity = types.length;
    return polymorphicType(type_1.Constructor.Tuple[arity], types);
}
exports.tupleType = tupleType;
function unboundScheme(type) {
    return makeScheme([], type);
}
exports.unboundScheme = unboundScheme;
function makeScheme(bound, type) {
    return {
        bound: new Set(bound),
        type,
    };
}
exports.makeScheme = makeScheme;
function freeTypeVars(type) {
    switch (type.kind) {
        case type_1.TypeKind.Number:
        case type_1.TypeKind.Boolean:
        case type_1.TypeKind.Character:
        case type_1.TypeKind.BigInt:
            return new Set();
        case type_1.TypeKind.Variable:
            return new Set([type.name]);
        case type_1.TypeKind.Function:
            return util_1.union(freeTypeVars(type.input), freeTypeVars(type.output));
        case type_1.TypeKind.Polymorphic:
            return type.parameters.reduce((acc, param) => util_1.union(acc, freeTypeVars(param)), new Set());
        default:
            return util_1.assertUnreachable(type);
    }
}
exports.freeTypeVars = freeTypeVars;
function uncurriedFunctionType(input, output) {
    return {
        kind: type_1.TypeKind.Function,
        input,
        output,
    };
}
//# sourceMappingURL=builders.js.map